module.exports = __webpack_public_path__ + "static/media/gallery-16.b3c443f2.jpeg";